webpackJsonp([142629428675168],{

/***/ 306:
/***/ (function(module, exports) {

	module.exports = {"data":{"juliste":{"childImageSharp":{"sizes":{"aspectRatio":0.7071823204419889,"src":"/owla-ja-kadonnut-walkia/static/owla_juliste_some_v3-e38367ec56db1c82b54927e4403c1e6c-b6f9f.jpg","srcSet":"/owla-ja-kadonnut-walkia/static/owla_juliste_some_v3-e38367ec56db1c82b54927e4403c1e6c-52923.jpg 175w,\n/owla-ja-kadonnut-walkia/static/owla_juliste_some_v3-e38367ec56db1c82b54927e4403c1e6c-82f41.jpg 350w,\n/owla-ja-kadonnut-walkia/static/owla_juliste_some_v3-e38367ec56db1c82b54927e4403c1e6c-b6f9f.jpg 700w,\n/owla-ja-kadonnut-walkia/static/owla_juliste_some_v3-e38367ec56db1c82b54927e4403c1e6c-40b14.jpg 1024w","sizes":"(max-width: 700px) 100vw, 700px"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-0a1f34b0b5b66c49ba08.js